<div class="title p-2">
    <div class="row">
        <div class="col d-flex justify-content-start">
            <h1 class="mx-1">Încarcă document semnat digital</h1>
        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>

<div class="container p-2">
    <div class="row">
        <div class="col">
            <form [formGroup]="validateDocumentForm" (ngSubmit)="submitDocumentSwitch()">

                <!-- ================= SECTIUNEA 1: Upload Document Semnat Digital ================= -->
                <div class="row" *ngIf="!applySeal">
                    <div class="col">
                        <div class="solicitare-card__upload">
                            <div class="solicitare-card__upload-header">
                                <p class="upload-text">
                                    <i class="fa-solid fa-file-pdf me-2"></i>
                                    <span *ngIf="data.doc_type !== 2">Fotografii/Documente</span>
                                    <!-- doc_type=2 fără sigiliu: Exemplar Semnatari (+ câmp separat pt Cetățean) -->
                                    <span *ngIf="data.doc_type == 2 && !canApplySeal">Încărcare exemplar Semnatari</span>
                                    <!-- doc_type=2 cu sigiliu: Exemplar Cetățean (backend gestionează intern automat) -->
                                    <span *ngIf="data.doc_type == 2 && canApplySeal">Încărcare exemplar Cetățean</span>
                                </p>
                                <button class="upload-btn" (click)="fileInput.click()" type="button">
                                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                    ÎNCARCĂ
                                </button>
                            </div>

                            <div class="solicitare-card__upload-files"
                                *ngIf="validateDocumentForm.get('file')?.value && !uploading.file">
                                <div class="solicitare-card__upload-file">
                                    <span class="solicitare-card__upload-file-name">
                                        {{ (validateDocumentForm.get('file')?.value.original_name.length > 30) ?
                                        (validateDocumentForm.get('file')?.value.original_name | slice: 0:30) + '..' :
                                        (validateDocumentForm.get('file')?.value.original_name) }}
                                    </span>
                                    <div>
                                        <button class="solicitare-card__upload-file-delete" type="button"
                                            matTooltip="Șterge fișierul încărcat" (click)="removeFile()">
                                            <img class="btn-img" src="assets/icons/delete.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                *ngIf="uploading.file"></mat-spinner>

                            <input type="file" accept="application/pdf" id="upload-file-input-0" #fileInput
                                name="fileInput" (change)="addFile($event)" style="display: none">
                        </div>
                    </div>
                </div>

                <!-- Exemplar Cetatean (doar pt doc_type == 2 FĂRĂ canApplySeal - upload manual) -->
                <div class="row my-3" *ngIf="data.doc_type == 2 && !applySeal && !canApplySeal">
                    <div class="col">
                        <div class="solicitare-card__upload">
                            <div class="solicitare-card__upload-header">
                                <p class="upload-text">Încărcare exemplar Cetățean</p>
                                <button class="upload-btn" (click)="fileInputCetatean.click()" type="button">
                                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                    ÎNCARCĂ
                                </button>
                            </div>

                            <div class="solicitare-card__upload-files"
                                *ngIf="validateDocumentForm.get('exemplarCetatean')?.value && !uploading.file">
                                <div class="solicitare-card__upload-file">
                                    <span class="solicitare-card__upload-file-name">
                                        {{ (validateDocumentForm.get('exemplarCetatean')?.value.original_name.length > 30) ?
                                        (validateDocumentForm.get('exemplarCetatean')?.value.original_name | slice: 0:30) + '..' :
                                        (validateDocumentForm.get('exemplarCetatean')?.value.original_name) }}
                                    </span>
                                    <div>
                                        <button class="solicitare-card__upload-file-delete" type="button"
                                            matTooltip="Șterge fișierul încărcat">
                                            <img class="btn-img" src="assets/icons/delete.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                *ngIf="isExemplarLoading"></mat-spinner>

                            <input type="file" accept="application/pdf" id="upload-file-input-0" #fileInputCetatean
                                name="fileInputCetatean" (change)="addFileCetatean($event)" style="display: none">
                        </div>
                    </div>
                </div>

                <!-- ================= SEPARATOR - SAU ================= -->
                <div class="row my-4" *ngIf="canApplySeal && data.type == 3">
                    <div class="col">
                        <div class="separator-line">
                            <hr>
                            <span class="separator-text">SAU</span>
                            <hr>
                        </div>
                    </div>
                </div>

                <!-- ================= SECTIUNEA 2: Aplica Sigiliu pe Document Existent ================= -->
                <div class="row" *ngIf="canApplySeal && data.type == 3">
                    <div class="col">
                        <div class="seal-option-card" [class.seal-active]="applySeal">
                            <div class="seal-option-header">
                                <mat-checkbox
                                    [checked]="applySeal"
                                    (change)="onApplySealChange($event)"
                                    color="primary">
                                    <span class="seal-option-label">
                                        <i class="fa-solid fa-stamp me-2"></i>
                                        Aplica Sigiliu Institutional
                                    </span>
                                </mat-checkbox>
                            </div>

                            <div class="seal-option-content" *ngIf="applySeal">
                                <div class="existing-doc-info mb-3">
                                    <!-- doc_type = 1: Un singur exemplar -->
                                    <div class="alert alert-info mb-0" *ngIf="data.doc_type !== 2">
                                        <i class="fa-solid fa-file-signature me-2"></i>
                                        <strong>Document existent:</strong> Se va aplica sigiliul pe ultimul document semnat electronic din sistem.
                                    </div>
                                    <!-- doc_type = 2: Două exemplare -->
                                    <div class="alert alert-info mb-2" *ngIf="data.doc_type == 2">
                                        <i class="fa-solid fa-file-signature me-2"></i>
                                        <strong>Exemplar Cetățean:</strong> Se va aplica sigiliul electronic pe exemplarul destinat cetățeanului.
                                    </div>
                                    <div class="alert alert-secondary mb-0" *ngIf="data.doc_type == 2">
                                        <i class="fa-solid fa-copy me-2"></i>
                                        <strong>Exemplar Intern:</strong> Exemplarul pentru primărie/UAT va fi păstrat automat fără sigiliu (ultima versiune semnată).
                                    </div>
                                </div>

                                <p class="seal-info-text">
                                    <i class="fa-solid fa-info-circle me-2"></i>
                                    <span *ngIf="data.doc_type !== 2">Selectati pozitia pe document unde doriti sa aplicati sigiliul electronic institutional.</span>
                                    <span *ngIf="data.doc_type == 2">Selectati pozitia pe exemplarul cetățean unde doriti sa aplicati sigiliul electronic.</span>
                                </p>

                                <!-- Seal Position Selection -->
                                <div class="seal-position-section">
                                    <div *ngIf="!sealPosition" class="seal-no-position">
                                        <button type="button" class="btn btn-outline-primary"
                                            (click)="openSealPositionModalForExisting()"
                                            [disabled]="isLoadingSealPreview">
                                            <mat-spinner diameter="18" *ngIf="isLoadingSealPreview" class="me-2"></mat-spinner>
                                            <i class="fa-solid fa-crosshairs me-2" *ngIf="!isLoadingSealPreview"></i>
                                            Selecteaza Pozitia Sigiliului
                                        </button>
                                    </div>

                                    <div *ngIf="sealPosition" class="seal-position-info">
                                        <div class="seal-position-card">
                                            <div class="seal-position-icon">
                                                <i class="fa-solid fa-check-circle text-success"></i>
                                            </div>
                                            <div class="seal-position-details">
                                                <span class="seal-position-title">Pozitie Selectata</span>
                                                <span class="seal-position-data">
                                                    Pagina {{ sealPosition.pageNumber }} |
                                                    X: {{ sealPosition.x }}, Y: {{ sealPosition.y }} |
                                                    {{ sealPosition.width }}x{{ sealPosition.height }} pt
                                                </span>
                                            </div>
                                            <div class="seal-position-actions">
                                                <button type="button" class="btn btn-sm btn-outline-secondary me-2"
                                                    (click)="openSealPositionModalForExisting()"
                                                    [disabled]="isLoadingSealPreview">
                                                    <i class="fa-solid fa-pen me-1"></i>
                                                    Modifica
                                                </button>
                                                <button type="button" class="btn btn-sm btn-outline-danger"
                                                    (click)="clearSealPosition()">
                                                    <i class="fa-solid fa-times me-1"></i>
                                                    Sterge
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ================= Butoane Actiune ================= -->
                <div class="row mt-4">
                    <div class="col">
                        <div class="d-flex justify-content-end">
                            <button type="button" class="buttons me-2" mat-flat-button (click)="closeDialog()">
                                {{ helper.dialogConfig.buttonLabels.close }}
                            </button>
                            <button class="buttons" mat-flat-button color="primary" type="button"
                                [disabled]="!isFormValidForSubmit()"
                                (click)="submitWithSeal()">
                                <i class="fa-solid fa-stamp me-1" *ngIf="applySeal && sealPosition"></i>
                                {{ getSubmitButtonLabel() }}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="section-spinner position-absolute" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>